export const getSubCategory = subCategoryId => ({ sub_categories }) =>
  sub_categories.subCategoryList.find(({ id }) => id === subCategoryId);
